import { PlusCircleOutlined } from "@ant-design/icons";
import { Button, Form, Modal, message } from "antd";
import React from "react";
import { PostAPIRequest } from "../../../../services";
import FinancialCalendarNewItem from "../../FinancialCalendar/FinancialCalendarNewItem";
import moment from "moment";

const AddFinancialCalendar = (props) => {
  const [visible, setVisible] = React.useState(false);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [form] = Form.useForm();
  const showModal = () => {
    setVisible(true);
  };

  const handleOk = async () => {
    let row = await form.validateFields();
    console.log("Received values of form: ", row);
    row.date = moment(row.date).format("YYYY-MM-DD");
    var url = "/launchtracker/api/v1/financialcalendar/save";
    PostAPIRequest({
      url: url,
      data: row,
    }).then((response) => {
      message.success("Successfully created")
      form.resetFields()
      setConfirmLoading(true);
      setTimeout(() => {
        setVisible(false);
        setConfirmLoading(false);
      }, 1000);
      props.callback();
    }).catch((error) => {
      message.error("Something went wrong. Please try again later.")
    });
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setVisible(false);
    form.resetFields();
  };

  return (
    <>
      <Button size="large" type="primary" onClick={showModal}>
        <PlusCircleOutlined />
        Add Financial Calendar
      </Button>
      <Modal
        bodyStyle={{ overflowX: "auto", maxHeight: "calc(80vh - 200px)" }}
        title="Add Financial Calendar"
        visible={visible}
        width={600}
        onCancel={handleCancel}
        footer={[
          <Button key="back" className="cancel-btn atn-btn" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={confirmLoading}
            onClick={handleOk}
          >
            Submit
          </Button>,
        ]}
      >
        <FinancialCalendarNewItem handleCancel={handleCancel} form={form} financialcalendar={props.financialcalendar} />
      </Modal>
    </>
  );
};

export default AddFinancialCalendar;
